/** SummaryBand.jsx - the headline completion figures across all disciplines. */
import { CONDENSED, GREEN, INK_SOFT, LABEL, RULE } from './theme';
import { rollUp } from './helpers';
import { Bar } from './Primitives';

export function SummaryBand({ disciplines }) {
  const roll = rollUp(disciplines);
  // Nothing tracked yet: a headline "0%" would read as bad news rather than
  // "not started", so the band drops to a single explanatory line.
  const bare = roll.total === 0;
  return (
    <section style={{ paddingTop: 17 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 18,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div style={LABEL}>Overall completion</div>
          <div
            style={{
              marginTop: 7,
              fontSize: 12.5,
              color: INK_SOFT,
              lineHeight: 1.5,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {bare
              ? 'No sign-off items recorded on this project yet.'
              : roll.signed +
                ' of ' +
                roll.total +
                ' sign-off items signed across ' +
                disciplines.length +
                (disciplines.length === 1 ? ' discipline' : ' disciplines')}
          </div>
        </div>
        {!bare && (
          <div
            className="svm-pct"
            style={{
              fontFamily: CONDENSED,
              fontWeight: 700,
              color: GREEN,
              lineHeight: 0.82,
              letterSpacing: '-1px',
              fontVariantNumeric: 'tabular-nums',
              flexShrink: 0,
            }}
          >
            {roll.pct}
            <span style={{ fontSize: '0.36em', letterSpacing: '0.5px', marginLeft: 3 }}>%</span>
          </div>
        )}
      </div>
      {!bare && (
        <div style={{ marginTop: 13 }}>
          <Bar pct={roll.pct} height={12} />
        </div>
      )}
      <div style={{ height: 1, background: RULE, marginTop: 18 }} />
    </section>
  );
}

/* ------------------------------ discipline index ----------------------------- */
